import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterItem, FilterType } from './FilterItem';
import { FiltersProvider } from './FiltersProvider';
import styles from './filter_box.module.scss';

const searchTypePlaceholder = (searchType: 'arret' | 'commentary' | 'law') => {
  return {
    arret: (
      <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/1" />
    ),
    commentary: (
      <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/2" />
    ),
    law: (
      <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/3" />
    ),
  }[searchType];
};

type Props = {
  searchType: 'arret' | 'commentary' | 'law';
};

export const FilterBox: FC<Props> = ({ searchType }) => {
  const [showFullList, setShowFullList] = useState<boolean | null>(null);
  const FILTER_DISPLAY_MAX_NUMBER = 4;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/4" />
      </div>
      <div className={styles.content}>
        <FiltersProvider>
          {(filters: Array<FilterType>) => {
            if (
              showFullList === null &&
              filters.length > FILTER_DISPLAY_MAX_NUMBER
            )
              setShowFullList(false);
            else if (filters.length <= FILTER_DISPLAY_MAX_NUMBER)
              setShowFullList(null);
            const filterListToDisplay = showFullList
              ? filters
              : filters.slice(0, FILTER_DISPLAY_MAX_NUMBER);
            return filterListToDisplay.length > 0 ? (
              filterListToDisplay.map(filter => (
                <FilterItem
                  key={filter.labelFull || filter.label || filter.title}
                  filter={filter}
                />
              ))
            ) : (
              <span className={styles.emptyText}>
                {searchTypePlaceholder(searchType)}
              </span>
            );
          }}
        </FiltersProvider>
      </div>
      {showFullList === false && (
        <button
          className={styles.seeMore}
          onClick={() => setShowFullList(true)}
          type="button"
        >
          <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/5" />{' '}
          <i className="material-icons icons__keyboard_arrow_down" />
        </button>
      )}
      {showFullList === true && (
        <button
          className={styles.seeMore}
          onClick={() => setShowFullList(false)}
          type="button"
        >
          <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/6" />{' '}
          <i className="material-icons icons__keyboard_arrow_up" />
        </button>
      )}
    </div>
  );
};
